import React from "react";
import Dropdown from "src/components/Dropdown";
import { useIsMobile } from "src/hooks/useIsMobile";
import { Dropdowns, ExportButtonContainer, TableHeader } from "./styles";
import { CleaningLogsHeaderProps } from "./types";
import { IconDefinition } from "@fortawesome/pro-light-svg-icons";
import Button from "src/components/Button";
import { faShare } from "@fortawesome/pro-solid-svg-icons";

const CleaningLogsHeader = ({
  onDropDownItemClick,
  defaultItem,
  items,
  exportButtonHandler,
  isLoading,
}: CleaningLogsHeaderProps) => {
  const { isMobile } = useIsMobile();

  return (
    <TableHeader>
      <ExportButtonContainer>
        <Button
          additionalStyles={{
            float: "unset",
            borderRadius: "10px",
            padding: "9px 20px",
            margin: "0 0 0 auto",
          }}
          icon={faShare as IconDefinition}
          text="Export"
          onClick={exportButtonHandler}
          loading={isLoading}
        />
      </ExportButtonContainer>
      <Dropdowns $isMobile={isMobile}>
        <Dropdown
          id="filters-dropdown"
          width="220px"
          onClick={onDropDownItemClick}
          items={items}
          selectedDropdownItem={defaultItem}
        />
      </Dropdowns>
    </TableHeader>
  );
};

export default CleaningLogsHeader;
